import BrandSlider from "../../../components/Brands/Brands";
import NavCategoryPage from "./NavbarCategory";
import { useNavigate } from "react-router-dom";
const CategoryOne = ({ selectedCategory }) => {
  const navigate = useNavigate();
  return (
    <>
    

      <NavCategoryPage slug={selectedCategory} />

      {/* ✅ HERO BANNER */}
      <div
        style={{
          marginTop: "40px",
          position: "relative",
          width: "100%",
          height: "470px",
          backgroundImage: "url('/about.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* DARK OVERLAY */}
        <div
        
        />

        {/* TEXT CONTENT */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: "50px",
            color: "#fff",
            maxWidth: "500px",
          }}
        >
          <h2 style={{ fontSize: "36px", marginBottom: "10px" }}>
          Where  Style Meets Sophistication
          </h2>

          <p style={{ fontSize: "16px", opacity: 0.9, marginBottom: "20px" }}>
            Discover premium collections crafted for elegance, comfort, and modern living.
          </p>

          <button   onClick={() => navigate("/shop")}
            style={{
              width: "fit-content",
              padding: "12px 24px",
              background: "#fff",
              color: "#000",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Discover Now
          </button>
        </div>
      </div>
      <div>
        <BrandSlider/>
      </div>
    </>
  );
};

export default CategoryOne;